const LogisticReport = () => {
  return <div>LogisticReport</div>;
};

export default LogisticReport;
